<form class="row form-group mt-4 align-items-center monthly-commission" [formGroup]="searchForm">
  <div class="col-6 col-md-2">
    <mat-form-field>
      <input matInput [matDatepicker]="fromDate" placeholder="Start" formControlName="fromDate" (dateChange)="getSearchData()"
        readonly/>
      <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
      <mat-datepicker panelClass="greengo" #fromDate></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-6 col-md-2">
    <mat-form-field>
      <input matInput [matDatepicker]="toDate" placeholder="End" formControlName="toDate" (dateChange)="getSearchData()" readonly/>
      <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
      <mat-datepicker panelClass="greengo" #toDate></mat-datepicker>
    </mat-form-field>
  </div>
  <span>Total commission for this period GBP {{totalCommission | transformNumber}}</span>
</form>
<ng-table [rows]="rows" [columns]="columns" [maxHeight]="45">
</ng-table>